// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");

function blob(blob$1) {
  return blob$1;
}

function file(file$1) {
  return file$1;
}

function string(str) {
  return str;
}

function promise(promise$1) {
  return promise$1;
}

var JsType = {
  blob: blob,
  file: file,
  string: string,
  promise: promise
};

function toJsType(data) {
  switch (data.TAG | 0) {
    case /* Blob */0 :
    case /* File */1 :
    case /* String */2 :
        return data._0;
    case /* Promise */3 :
        return data._0.then(function (resolved) {
                    switch (resolved.TAG | 0) {
                      case /* Blob */0 :
                      case /* File */1 :
                      case /* String */2 :
                          return Promise.resolve(resolved._0);
                      
                    }
                  });
    
  }
}

var ClipboardItemData = {
  JsType: JsType,
  toJsType: toJsType
};

function view(type_) {
  return type_;
}

var Type = {
  view: view
};

function make(maybePresentationStyle, clipboardDataByType) {
  var maybeInitOptionsWithString = Belt_Option.map(maybePresentationStyle, (function (presentationStyle) {
          return {
                  presentationStyle: presentationStyle
                };
        }));
  return new ClipboardItem(Js_dict.fromArray(Belt_MapString.toArray(Belt_MapString.map(clipboardDataByType, toJsType))), maybeInitOptionsWithString);
}

function ClipboardItem_types(prim) {
  return prim.types;
}

function ClipboardItem_getByType(prim0, prim1) {
  return prim0.getType(prim1);
}

var ClipboardItem$1 = {
  Type: Type,
  types: ClipboardItem_types,
  getByType: ClipboardItem_getByType,
  make: make
};

function readText(prim) {
  return navigator.clipboard.readText();
}

function writeText(prim) {
  return navigator.clipboard.writeText(prim);
}

function read(prim) {
  return navigator.clipboard.read();
}

function write(prim) {
  return navigator.clipboard.write(prim);
}

exports.ClipboardItemData = ClipboardItemData;
exports.ClipboardItem = ClipboardItem$1;
exports.readText = readText;
exports.writeText = writeText;
exports.read = read;
exports.write = write;
/* No side effect */
